module.exports = __webpack_public_path__ + "static/img/10.396929b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/4/zh/10.png
// module id = WybA
// module chunks = 0